module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/4.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "para-c"
  }, [_vm._v("THORNDIKE & SWANN REGENCY MYSTERIES")]), _vm._v(" "), _c('p', {
    staticClass: "para-c"
  }, [_c('em', [_vm._v("The Debutante’s Code")])]), _vm._v(" "), _c('p', {
    staticClass: "para-c"
  }, [_c('em', [_vm._v("Millstone of Doubt")])]), _vm._v(" "), _c('p', {
    staticClass: "para-c"
  }, [_c('em', [_vm._v("Children of the Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("SERENDIPITY & SECRETS")]), _vm._v(" "), _c('p', {
    staticClass: "para-c"
  }, [_c('em', [_vm._v("The Lost Lieutenant")])]), _vm._v(" "), _c('p', {
    staticClass: "para-c"
  }, [_c('em', [_vm._v("The Gentleman Spy")])]), _vm._v(" "), _c('p', {
    staticClass: "para-c"
  }, [_c('em', [_vm._v("The Indebted Earl")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Joy to the World: A Regency Christmas Collection")]), _vm._v(" by Carolyn Miller, Amanda Barratt, and Erica Vetsch")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9da7bbf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_FM02.vue
// module id = 63
// module chunks = 0